
import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { InvestmentDetail } from '../investment-detail/investment-detail';

import styles from './order-form.module.scss';
import { useValidation } from '../../../../hooks/use-validation';
import { investorInfoValidator2, investorInfoOrderObj2 } from '../../../../form-control/order-form/order-form-control';
import { getInvestorCategory, getCountries, getIDTypes, getSecurityRegistrationOptions,
         getTaxStatuses, getSettBankList, getDeliveryModes, getModeOfPayments,
         getPlaceList, getModeOfCollectionOfInterests } from '../../../../helpr/orderFormData';
import { FormGroup, DropDown, TextInput, DateInput, RadioButton, RadioTextInput, CheckBoxes } from '../../../../components/form/form';

import ApplicantNamesInput from './components/applicant-names-field/applicant-names-field';
import ModeOfPayment from './components/mode-of-payment/mode-of-payment';

import addButton from '../../../../assets/add-button.svg';
import closeButton from '../../../../assets/close.svg';

const OrderForm2 = ({session, orderInfo, saveOrderFormState, purchaseAmount, nextStep}) => {
  const orderFormState = useValidation(investorInfoValidator2, investorInfoOrderObj2(orderInfo), {border: '1px solid red'});
  const { validate, getField, getDropdownProps, getTextFieldProps, getRadioButtonProps, getCheckBoxesProps, forceSetField, getTextFieldPropsDynamic, getDynamicField, setDynamicField } = orderFormState;
  const [ presentAddressFlag, setPresentAddressFlag ] = useState(false);
  const required = (name) => <a>{name}<span className={styles['red']}>*</span></a>;
  const saveFormData = (step) => {
    var { formState, isFormValid } = validate();
    saveOrderFormState(formState);
    if( step ){ nextStep(step); }
    else if ( isFormValid ) { nextStep(step) }
    else {/*Invalid Form State*/}
  }

  /*
    Copy permanent address to present address
    and set form field values.
  */
  const copyAddress = (checkValue) => {
    if( !checkValue ){
      forceSetField('presentAddressStreet', '');
      forceSetField('presentAddressDistrictTown', '');
      forceSetField('presentAddressStateProvinceRegion', '');
      forceSetField('presentAddressCountry', '');
      forceSetField('presentAddressCity', '');
      forceSetField('presentAddressZipCode', '');
    } else {
      forceSetField('presentAddressStreet', getField('addressStreetAddress'));
      forceSetField('presentAddressDistrictTown', getField('addressDistrictOrTown'));
      forceSetField('presentAddressStateProvinceRegion', getField('addressStateProvinceRegion'));
      forceSetField('presentAddressCountry', getField('addressCountry'));
      forceSetField('presentAddressCity', getField('addressCity'));
      forceSetField('presentAddressZipCode', getField('addressZipcode'));
    }
  }

  const copyPermanentAddressHandler = (e) => {
    const checkValue = e.target.checked;
    setPresentAddressFlag(checkValue);
    copyAddress(checkValue);
  }

  const removeContactNumber = (index, field) => {
    const contactNumber = getDynamicField(field);
    var array = [ ...contactNumber ];
    array.splice(index, 1)
    setDynamicField(field, array);
  }

  const addContactNumber = (field) => {
    const contactNumber = getDynamicField(field).concat({
      number: {value: '', style: {}}
    })
    setDynamicField(field, contactNumber)
  }

  const renderContactButton = (index, field) => {
    const fieldLength = getDynamicField(field).length;
    if( fieldLength > 1 && index < fieldLength - 1 ){
      return (
        <div className={styles['button']}>
          <img onClick={()=>removeContactNumber(index, field)} src={closeButton}/>
        </div>
      )
    }
    if( fieldLength - 1 === index ){
      return (
        <div className={styles['button']}>
          <img onClick={()=>addContactNumber(field)} src={addButton}/>
        </div>
      )
    }
  }

  return (
    <div className={styles['order-form-component']}>
      <Row>
        <Col sm={12} lg={8}>
          <FormGroup header="CONTACT NUMBERS">
            <Row>
              <Col className={styles['multi-fields']}>
                <div className={styles['field']}>
                  <div className={styles['field-label']}>
                    TELEPHONE NUMBER:
                  </div>
                </div>
                <div>
                  <Row className={styles['field-input']} mt="1">
                    <Col>
                      { getDynamicField('contactTelephoneNumbers').map((_, index)=>{
                        return (
                          <Row key={index} mt="1">
                            <Col md="6">
                              <TextInput inputProps={getTextFieldPropsDynamic('contactTelephoneNumbers', 'number', index)} maxLength="30"/>
                            </Col>
                            <Col md="3">
                              { renderContactButton(index, 'contactTelephoneNumbers') }
                            </Col>
                          </Row>
                        )
                      }) }
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className={styles['multi-fields']}>
                <div className={styles['field']}>
                  <div className={styles['field-label']}>
                    FAX NUMBER:
                  </div>
                </div>
                <div>
                  <Row className={styles['field-input']} mt="1">
                    <Col>
                      { getDynamicField('contactFaxNumbers').map((_, index)=>{
                        return (
                          <Row key={index} mt="1">
                            <Col md="6">
                              <TextInput inputProps={getTextFieldPropsDynamic('contactFaxNumbers', 'number', index)} maxLength="30"/>
                            </Col>
                            <Col md="3">
                              { renderContactButton(index, 'contactFaxNumbers') }
                            </Col>
                          </Row>
                        )
                      }) }
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup header="MAILING ADDRESS">
            <Row>
              <Col md="6">
                <DropDown inputProps={getDropdownProps('statementDeliveryMode')} values={getDeliveryModes()}>
                  { required('STATEMENT DELIVERY MODE:') }
                </DropDown>
              </Col>
              <Col md="6">
                <DropDown inputProps={getDropdownProps('place')} values={getPlaceList()}>
                  { required('PLACE OF RESIDENCE:') }
                </DropDown>
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInput inputProps={getTextFieldProps('addressStreetAddress')} placeholder={"House/Lot/Block/Unit no., Floor & Building, Street, Subdivision/Barangay/Village"} maxLength="70">
                  { required('PERMANENT ADDRESS:') }
                </TextInput>
              </Col>
            </Row>
            <Row className="row mt-1">
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('addressDistrictOrTown')} placeholder={"District/Town"} maxLength="70"/>
              </Col>
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('addressCity')} placeholder={"City"} maxLength="70"/>
              </Col>
            </Row>
            <Row className="row mt-1">
              <Col md="6">
                <DropDown inputProps={getDropdownProps('addressCountry')} values={getCountries()} selectName="Country"/>
              </Col>
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('addressStateProvinceRegion')} placeholder={"State/Province/Region"} maxLength="70"/>
              </Col>
            </Row>
            <Row className="row mt-1">
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('addressZipcode')} placeholder={"Zip Code"} maxLength="5"/>
              </Col>
            </Row>
            <Row className="row mt-2">
              <Col>
                <TextInput
                  inputProps={getTextFieldProps('presentAddressStreet')}
                  placeholder={"House/Lot/Block/Unit no., Floor & Building, Street, Subdivision/Barangay/Village"}
                  maxLength="70"
                  disabled={presentAddressFlag}>
                  { required('PRESENT MAILING ADDRESS:') }
                  <Row className="mt-0">
                    <Col>
                      <div>
                        <label className={styles['remarks']}>
                          <i>(If different from permanent address)</i>
                        </label>
                      </div>
                      <div>
                        <label className={styles['text']}>
                          <input type="checkbox" onChange={(e)=>{copyPermanentAddressHandler(e)}}/>
                          <span className={styles['label']}>same as above</span>
                        </label>
                      </div>
                    </Col>
                  </Row>
                </TextInput>
              </Col>
            </Row>
            <Row className="row mt-1">
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('presentAddressDistrictTown')} placeholder={"District/Town"} maxLength="70" disabled={presentAddressFlag}/>
              </Col>
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('presentAddressCity')} placeholder={"City"} maxLength="70" disabled={presentAddressFlag}/>
              </Col>
            </Row>
            <Row className="row mt-1">
              <Col md="6">
                <DropDown inputProps={getDropdownProps('presentAddressCountry')} values={getCountries()} selectName="Country"/>
              </Col>
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('presentAddressStateProvinceRegion')} placeholder={"State/Province/Region"} maxLength="70" disabled={presentAddressFlag}/>
              </Col>
            </Row>
            <Row className="row mt-1">
              <Col md="6">
                <TextInput inputProps={getTextFieldProps('presentAddressZipCode')} placeholder={"Zip Code"} maxLength="5" disabled={presentAddressFlag}/>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <ModeOfPayment orderFormState={orderFormState}/>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col md="6">
                <RadioButton inputProps={getRadioButtonProps('modeOfCollectionOfInterest')} data={getModeOfCollectionOfInterests()}>
                  { required('MODE OF COLLECTION OF INTEREST AND PRINCIPAL PAYMENT:') }
                </RadioButton>
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInput inputProps={getTextFieldProps('bankPesoAccountNumber')} placeholder={"XXXX"} maxLength="18">
                  { required('PESO BANK ACCOUNT NO. / BIC CODE:') }
                </TextInput>
              </Col>
              <Col>
                <DropDown inputProps={getDropdownProps('settBankCode')} values={getSettBankList()}>
                  { required('SETTLEMENT BANK:') }
                </DropDown>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col md="6">
                <RadioButton inputProps={getRadioButtonProps('securityRegistration')} data={getSecurityRegistrationOptions()}>
                  REGISTRATION OF SECURITIES:
                </RadioButton>
              </Col>
            </Row>
            {
              getField('securityRegistration') === 'PDTC_CORP' &&
              <>
                <Row>
                  <Col>
                    <Row>
                      <Col>
                        <TextInput inputProps={getTextFieldProps('pdtcDepositoryParticipantName')} maxLength="150">
                          NAME OF PDTC DEPOSITORY PARTICIPANT:
                        </TextInput>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <TextInput inputProps={getTextFieldProps('applicantNoCDBPID')} maxLength="11">
                          APPLICANT NoCD/BP ID:
                        </TextInput>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <TextInput inputProps={getTextFieldProps('pdtcDepositoryParticipantBPID')} maxLength="11">
                          PDTC DEPOSITORY PARTICIPANT BP ID:
                        </TextInput>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <TextInput inputProps={getTextFieldProps('pdtcDepositoryParticipantOmnibusAccNo')} maxLength="15">
                          PDTC DEPOSITORY PARTICIPANT OMNIBUS ACCOUNT NO.:
                        </TextInput>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <div>
                      <b>Depository Participant Confirmation and Certification</b>
                    </div>
                    <div>
                      <p><i>(Note: This is for Depository Participant Lodging Securities under the PDTC NoCD Facility)</i></p>
                      <p>We confirm that we are a PDTC Depository Participant and certify that:</p>
                      <p>1. The securities being lodged in our Depository Account under the PDTC NoCD Facility are securities being purchased by our
                         bonafide clients and shall make available the documents evidencing the clients’ instructions to purchase the Security upon the
                         request of the Issuer, its agent/s and the regulators.</p>
                      <p>2. We have done, or as applicable relied upon (on the basis of a third party reliance letter issued by an appropriate institution
                         in accordance with current banking regulations), the necessary know-your-customer procedures to verify the identity of the client.</p>
                      <p>3. Our clients acknowledge and fully understand that by lodging the security in the Depository under the clients’ NoCD accounts, the
                         security shall be registered under the name of PDTC Nominee Corp. in the registry records of the Issuer</p>
                      <p>4. We have obtained the consent of the relevant clients to the sharing of the client information to the Issuer or to its authorized
                         agent for purposes of regulatory compliance and processing of corporate actions.</p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p>
                      By clicking the NEXT button, we confirm that we are a PDTC Depository Participant and certify the above.
                    </p>
                  </Col>
                </Row>
              </>
            }
          </FormGroup>
        </Col>
        <Col>
          <InvestmentDetail
            issuer={session['securityIssuer']}
            issue={session['securityName']}
            issueLogo={session.securityLogoSrc}
            offerPeriod={session['securityOfferDate']}
            purchaseAmount={purchaseAmount}
            currencyType={session['currency']}
          />
        </Col>
      </Row>
      <Row className={styles['btn-actions']}>
        <Button className="btn-secondary" onClick={()=>saveFormData(true)}>BACK</Button>
        <Button onClick={()=>{saveFormData(false)}}>NEXT</Button>
      </Row>
    </div>
  )
}

export default OrderForm2;




